import { id } from "date-fns/locale";
import { DataBean } from "../DataBean";

export class EnjoyedVacation extends DataBean {
  public async getFortnightVacationsByEmployee(
    year: number,
    idAccount: number
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "java.util.List_getFortnightVacationsByEmployee_Number_Number",
      [year, idAccount]
    );
  }

  public async setVacationPeriodToDocument(
    idDocument: number,
    documentDate: any,
    vacYear: number,
    vacPeriod: string
  ): Promise<any> {
    return this.getCustomService(
      "QuickDataERPCore",
      "boolean_setVacationPeriodToDocument_Number_java.util.Date_Number_String",
      [idDocument, documentDate, vacYear, vacPeriod]
    );
  }
}
